export function compressAndResize(
  file: File,
  maxWidth = 1280,
  maxHeight = 1280,
  maxBytes = 1024 * 1024
): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const img = new Image();

      img.onload = () => {
        const ratioX = maxWidth / img.width;
        const ratioY = maxHeight / img.height;
        const ratio = Math.min(ratioX, ratioY, 1);
        const newWidth = Math.round(img.width * ratio);
        const newHeight = Math.round(img.height * ratio);

        const canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject(new Error('Canvas context unavailable'));
          return;
        }

        ctx.drawImage(img, 0, 0, newWidth, newHeight);

        for (let quality = 0.9; quality >= 0.5; quality -= 0.1) {
          const dataUrl = canvas.toDataURL('image/jpeg', quality);
          const sizeBytes = Math.round((dataUrl.length - 'data:image/jpeg;base64,'.length) * 0.75);

          if (sizeBytes <= maxBytes || quality <= 0.5) {
            resolve(dataUrl);
            return;
          }
        }

        resolve(canvas.toDataURL('image/jpeg', 0.5));
      };

      img.onerror = () => reject(new Error('Failed to load image'));
      img.src = reader.result as string;
    };

    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
}
